/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const deleteProjectsProjectidPreferencesUnitsUnitidPathProjectIdSchema = z.string()

export const deleteProjectsProjectidPreferencesUnitsUnitidPathUnitIdSchema = z.string()

export const deleteProjectsProjectidPreferencesUnitsUnitidStatus204Schema = z.string()

export const deleteProjectsProjectidPreferencesUnitsUnitidStatus400Schema = z.string()

export const deleteProjectsProjectidPreferencesUnitsUnitidStatus401Schema = z.string()

export const deleteProjectsProjectidPreferencesUnitsUnitidStatus404Schema = z.string()

export const deleteProjectsProjectidPreferencesUnitsUnitidStatus500Schema = z.string()

export const deleteProjectsProjectidPreferencesUnitsUnitidResponseSchema = deleteProjectsProjectidPreferencesUnitsUnitidStatus204Schema

export const deleteProjectsProjectidPreferencesUnitsUnitidErrorSchema = z.union([deleteProjectsProjectidPreferencesUnitsUnitidStatus400Schema, deleteProjectsProjectidPreferencesUnitsUnitidStatus401Schema, deleteProjectsProjectidPreferencesUnitsUnitidStatus404Schema, deleteProjectsProjectidPreferencesUnitsUnitidStatus500Schema])
